module.exports = __webpack_public_path__ + "files/11f07ad955a39a06c64c082178974301.png";